// import { Button } from "bootstrap";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import FormInputs from "../../components/UI/FormInputs";
import { fetchTimeInterval, getCurrentDate, getCurrentTime, getLookupByKey, isObject, isSet, isVisitInFuture, isVisitInPast } from "../../utils/commonUtils";
import { VISIT_CATEGORY } from "../../utils/constant";
import Buttons from "../../components/UI/Buttons";
import VisitsService from "../../services/VisitsService";
import WithRoutify from "../../hoc/WithRoutify";
import CompanyService from "../../services/CompanyService";
import moment from "moment";

const AddFollowUp = (props) => {
  const { visitId, clinicId, isOpen, modalToogleHandler, fetchRecords, Toast } = props;
  const [validation, setValidation] = useState({});
  const [formData, setFormData] = useState({});
  const [visitCategoryOptions, setvisitCategoryOptions] = useState([]);
  const [employeeHolidays, setEmployeeHolidays] = useState([]);
  const [employeeAvailability, setEmployeeAvailability] = useState([]);
  const [employeeDisabledDays, setEmployeeDisabledDays] = useState([]);
  const [allowedRanges, setAllowedRanges] = useState([]);
  const [dayNameMap, setDayNameMap] = useState({
     MON: "Monday",
              TUE: "Tuesday", 
              WED: "Wednesday",
              THU: "Thursday",
              FRI: "Friday",
              SAT: "Saturday", 
              SUN: "Sunday",
  });

  useEffect(() => {
    if (!isOpen || !visitId) return;

    const resolveAndFetch = async () => {
      let resolvedClinicId = clinicId;
      console.log('resolvedClinicId',resolvedClinicId)
      if (resolvedClinicId) {
        fetchClinicAvailabilityByClinic(resolvedClinicId);
      }
      fetchVisitCategory();
    };

    resolveAndFetch();
  }, [isOpen, visitId, clinicId]);

  useEffect(() => {
    // 🛑 Skip if no availability and no holidays yet
    if (!employeeAvailability?.length && !employeeHolidays?.length && !employeeDisabledDays?.length) {
      return;
    }
  
    const today = getCurrentDate();
    const currentTime = getCurrentTime().toString().padStart(2, "0");
  
    // Get today's weekday name (e.g., "Thursday")
    const dayName = new Date(today).toLocaleDateString("en-US", { weekday: "long" });
  
    // 🛑 Step 1: Check if today is a holiday
    const isHoliday = employeeHolidays?.includes(today);
  
    // 🛑 Step 2: Check if today is in employeeDisabledDays
    const isDisabledDay = employeeDisabledDays?.includes(dayName);
  
    if (isHoliday || isDisabledDay) {
      // If today is a holiday or disabled day → clear date & time
      setFormData((prev) => ({
        ...prev,
        visit_date: "",
        visit_time: "",
      }));
      setAllowedRanges([]);
      return; // ⛔ Stop further execution
    }
  
    // 🟢 Step 3: Find today's availability if not holiday/disabled
    const matchingDay = employeeAvailability.find(
      (dayObj) => dayNameMap[dayObj.day] === dayName
    );
  
    let updatedVisitTime = currentTime;
  
    if (matchingDay && matchingDay.slots && matchingDay.slots.length > 0) {
      const formattedSlots = matchingDay.slots.map((slot) => ({
        from: slot.from_time,
        to: slot.to_time,
      }));
  
      // ✅ Check if current time is inside available slots
      const isTimeInsideSlots = formattedSlots.some((slot) => {
        const visitMoment = moment(updatedVisitTime, "hh:mm A");
        const fromMoment = moment(slot.from, "hh:mm A");
        const toMoment = moment(slot.to, "hh:mm A");
        return visitMoment.isBetween(fromMoment, toMoment, null, "[]");
      });
  
      // If current time is not inside slots → clear it
      if (!isTimeInsideSlots) {
        updatedVisitTime = "";
      }
  
      setAllowedRanges(formattedSlots);
    } else {
      // ⚡ No slots available → DON'T clear visit_time
      setAllowedRanges([]);
    }
  
    // ✅ Step 4: Finally set today's default values
    setFormData((prev) => ({
      ...prev,
      visit_date: today,
      visit_time: updatedVisitTime,
    }));
  }, [employeeAvailability, employeeHolidays, employeeDisabledDays]);
  
  const fetchVisitCategory = async () => {
    const key = await getLookupByKey(VISIT_CATEGORY);
    setvisitCategoryOptions(key);
  }

  const inputFields = [
    {
      type: "Date",
      label: "Visit Date",
      placeholder: "",
      className: "form-control form-control-solid",
      name: "visit_date",
      required: true,
      disabledDates: employeeHolidays,
      disabledDays: employeeDisabledDays
    },
    {
      type: "SelectSearchList",
      label: "Visit Time",
      col: 'col-6',
      placeholder: "Visit Time",
      isAsync: true,
      options: [{ 'label': getCurrentTime(), value: getCurrentTime() }],
      loadCallBack: (val, callback) => fetchTimeInterval(val, callback,allowedRanges),
      className: "form-control form-control-solid",
      name: "visit_time",
      required: true,
    },
    {
      type: "SelectList",
      label: "Visit Category",
      placeholder: "",
      className: "form-control form-control-solid",
      name: "visit_category",
      options: visitCategoryOptions,
      required: true
    },
  ];

  const fetchClinicAvailabilityByClinic = async (clinicId) => {
    if (!clinicId) return;
    try {
      const clinicDetails = await CompanyService.clinicAvailabilityByClinic(clinicId);

      const holidays = clinicDetails?.holidays || [];
      const availability = clinicDetails?.availability || [];
      // Active holiday dates
      const activeHolidayDates = holidays
        .filter(h => h.is_active === 1)
        .map(h => h.date);
      // Disabled days (non-repeatable availability)
      const disabledDays = availability
        .filter(dayObj => dayObj.is_repeatable === 0)
        .map(dayObj => dayNameMap[dayObj.day] || dayObj.day);
      let updatedFormData = { ...formData };
      // If current visit_date is blocked, reset it
      if (formData.visit_date) {
        const dayName = new Date(formData.visit_date).toLocaleDateString("en-US", { weekday: "long" });
        const isBlockedDate =
          activeHolidayDates.includes(formData.visit_date) ||
          disabledDays.includes(dayName);
        if (isBlockedDate) {
          updatedFormData.visit_date = "";
        }
      }
      setEmployeeHolidays(activeHolidayDates);
      setEmployeeAvailability(availability);
      setEmployeeDisabledDays(disabledDays);
      setFormData(updatedFormData);

    } catch (err) {
      console.error("Error fetching clinic availability:", err);
    }
  };

  const changeHandler = (value, fieldName) => {
    console.log('changeHandler', value, fieldName);
  
    if (fieldName === "visit_date") {
      const dayName = new Date(value).toLocaleDateString("en-US", { weekday: "long" });
      console.log("dayName",dayName)
      console.log("dayNameMap",dayNameMap)
      console.log("employeeAvailability",employeeAvailability)
      // Find that day in availability
      const matchingDay = employeeAvailability.find(
        (dayObj) => dayNameMap[dayObj.day] === dayName
      );
      console.log("matchingDay",matchingDay)
      if (matchingDay && matchingDay.slots && matchingDay.slots.length > 0) {
        const formattedSlots = matchingDay.slots.map((slot) => ({
          from: slot.from_time, // e.g. "01:15 PM"
          to: slot.to_time,     // e.g. "10:00 PM"
        }));
  
        let updatedVisitTime = formData.visit_time;
        console.log("updatedVisitTime",updatedVisitTime)
        // ✅ Validate existing visit_time only if selected
        if (updatedVisitTime) {
          const isTimeStillValid = formattedSlots.some((slot) => {
            const visitMoment = moment(updatedVisitTime, "hh:mm A");
            const fromMoment = moment(slot.from, "hh:mm A");
            const toMoment = moment(slot.to, "hh:mm A");
            return visitMoment.isBetween(fromMoment, toMoment, null, "[]");
          });
          console.log("isTimeStillValid",isTimeStillValid)
          // ❌ If time is invalid → clear it
          if (!isTimeStillValid) {
            updatedVisitTime = "";
          }
        }
  
        // ✅ Update states when slots exist
        setFormData((prev) => ({
          ...prev,
          [fieldName]: value,
          visit_time: updatedVisitTime,
        }));
        setAllowedRanges(formattedSlots);
  
      } else {
        // ❌ No slots → keep the existing visit_time (DO NOT clear it)
        setFormData((prev) => ({
          ...prev,
          [fieldName]: value,
          visit_time: prev.visit_time, // ✅ keep old time
        }));
        setAllowedRanges([]);
      }
    } else {
      // ✅ Default case for all other fields
      setFormData((prev) => ({
        ...prev,
        [fieldName]: value,
      }));
    }
  
    // ✅ Clear validation for that field
    setValidation((prev) => ({
      ...prev,
      [fieldName]: "",
    }));
  };
  
  const formSubmitHandler = async () => {
    let payload = { ...formData };
    payload.visit_id = visitId;
    
    // Check if visit date and time is in the future, set status to "Scheduled"
    // Or if visit is in the past, set status to "New"
    if (payload.visit_date && payload.visit_time) {
      if (isVisitInFuture(payload.visit_date, payload.visit_time)) {
        payload.visit_status = 'Scheduled';
      } else if (isVisitInPast(payload.visit_date, payload.visit_time)) {
        payload.visit_status = 'New';
      }
    }
    
    const response = await VisitsService.createFollowUp(payload);
    let updateValidation = { ...validation };
    console.log('response', response);
    if (response.status && response.status === "ERROR") {
      if (isObject(response.data)) {
        for (let key in response.data) {
          updateValidation = {
            ...updateValidation,
            [key]: response.data[key].join(","),
          };
        }
      } else {
        props.Toast.error(response.data);
      }
      if (Object.keys(updateValidation).length > 0) {
        setValidation(updateValidation);
      }
    } else {
      // Backend automatically maps incident for Work Comp - Follow Up visits
      // from the parent visit (visitId), so no manual mapping needed
      fetchRecords();
      modalToogleHandler();
      Toast.success("Follow Up Added Successfully");
    }
  }

  return (
    <Modal
      show={isOpen}
      onHide={modalToogleHandler}
      dialogClassName="hResponsive"
      keyboard={false}
      backdrop="static"
    >
      <div className="sh_modalBox">
        <Modal.Header closeButton>
          <Modal.Title>
            <h6 className="text-lg mb-0 font-weight-bold">{"Follow Up"}</h6>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            {inputFields &&
              inputFields.map((field, index) => (
                <div className={`col-12`} key={index}>
                  <div className="form-group">
                    <label className="text-gray-900 text-md opacity-75">
                      {field.label}
                    </label>
                    <FormInputs
                      changeHandler={(val, e) => changeHandler(val, field.name, e)}
                      value={formData[field.name]}
                      {...field}
                    />
                    {isSet(validation[field.name], "") !== "" ? (
                      <span className="text-danger m-1">
                        {isSet(validation[field.name], "")}
                      </span>
                    ) : ("")}
                  </div>
                </div>
              ))}
          </div>
        </Modal.Body>

        <Modal.Footer className="d-flex justify-content-center">
          <Buttons
            type='Single'
            className="btn btn-primary"
            clickHandler={() => formSubmitHandler()}
            label='Submit'
            acl='visits-create' />
        </Modal.Footer>
      </div>
    </Modal>
  );
}
export default WithRoutify(AddFollowUp);
